export function getLessonSlug(pathname: string) {
  const pathParts = pathname.split('/');
  // Уроки могут быть как на домене журнала (journal.tinkoff.ru/intro-fingram/),
  // так и вложенными в учебник (journal.tinkoff.ru/pro/fingram/intro-fingram/)
  const lessonSlug = pathParts[1] === 'pro' ? pathParts[3] : pathParts[1];

  return lessonSlug;
}
